import React, { forwardRef, HTMLAttributes, SVGAttributes } from 'react';
import svgIcons from './getSvgs';
import SVGIcon from './SVGIcon';

import '../../common/fonts.less';
import '../../common/svg-icons.less';

const getIconClassName = (name: string): string =>
  `${name in svgIcons ? 'svg' : 'icon'}-${name}`;

interface IconProps {
  name: string;
  className?: string;
  title?: string;
}

type IconRef = SVGSVGElement | HTMLSpanElement;

const Icon = forwardRef<IconRef, IconProps & (HTMLAttributes<HTMLElement> | SVGAttributes<SVGSVGElement>)>(
  function Icon({ name, className = '', ...props }, ref) {
    return name in svgIcons ? (
      <SVGIcon
        className={`${className} ${getIconClassName(name)}`.trim()}
        icon={svgIcons[name]}
        {...(props as SVGAttributes<SVGSVGElement>)}
        ref={ref as React.Ref<SVGSVGElement>}
      />
    ) : (
      <span
        className={`${className} ${getIconClassName(name)}`.trim()}
        {...(props as HTMLAttributes<HTMLSpanElement>)}
        ref={ref as React.Ref<HTMLSpanElement>}
      />
    );
  }
);

Icon.displayName = 'Icon';

export default Icon;
